import React, { useState } from 'react';
import { Box } from '@primer/react';
import { useCommonContext } from '../../../../contexts/common';
import EnhancedTreeView from '../../../../components/phong-thi-tree-view/PhongThiTreeView';

interface TreeItem extends Record<string, any> {
  key: string | number;
  text: string;
  parent_key?: string | number;
}

interface PhongThiTreeSelectionProps {
  dataSource: TreeItem[];
  onSelectionChanged: (phongThi: { 
    ex_phongthi_id: number; 
    ex_kythi_monthi_id: number;
    text?: string;
    ky_mon_thi?: {
      ten_mon_thi: string;
      ten_hinh_thuc_thi: string;
    };
  } | null) => void;
}

const PhongThiTreeSelection: React.FC<PhongThiTreeSelectionProps> = ({
  dataSource,
  onSelectionChanged
}) => {
  const { translate } = useCommonContext();
  const [selectedKey, setSelectedKey] = useState<string | number | undefined>();

  const handleSelectionChanged = (item: TreeItem) => {
    setSelectedKey(item.key);
    onSelectionChanged({
      ex_phongthi_id: item.ex_phongthi_id,
      ex_kythi_monthi_id: item.ex_kythi_monthi_id,
      text: item.text,
      ky_mon_thi: item.ky_mon_thi
    });
  };

  return (
    <Box>
      <EnhancedTreeView
        dataSource={dataSource}
        selectedValue={selectedKey}
        onSelectionChanged={handleSelectionChanged}
        height={window.innerHeight - 180}
      />
    </Box>
  );
};

export default PhongThiTreeSelection;